(function (angular) {
	'use strict';

	angular
		.module('eventsModule')
		.directive('mixpanelTrack', [
			'mixpanelFactory',
			mixpanelTrackFunction
		]);

	function mixpanelTrackFunction(mixpanelFactory) {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var mixpanelObject;

				if(angular.isDefined(attrs.mixpanelObject)) {
					mixpanelObject = scope.$eval(attrs.mixpanelObject);
				}
				
				var event = angular.isDefined(attrs.mixpanelEvent) ? attrs.mixpanelEvent : 'click';

				elem.on(event, function() {
					mixpanelFactory.track(attrs.mixpanelTrack, mixpanelObject);
				});
			}
		};
	}
})(window.angular);